import React, { Component } from "react";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import moment from "moment";
import {
  Field,
  FieldArray,
  reduxForm,
  formValueSelector,
  reset
} from "redux-form";
import * as _ from "lodash";
import {
  Layout,
  Row,
  Col,
  Form,
  Input,
  Select,
  List,
  Card,
  Button,
  Modal,
  Table,
  Icon,
  Spin,
  Skeleton,
  Result
} from "antd";
import MediaQuery, { useMediaQuery } from "react-responsive";
import { numberFormat } from "../../utilities";
import { numFormat } from "../../utilities/format";
import DocumentMeta from "react-document-meta";

import config from "../../config";
import {
  fetchPermissions,
  fetchDrafts, cancelDraft
} from "../../actions";
import circle from "../../assets/images/home-banners/circle-pink.png";
import swap from "../../assets/icons/swap.svg";
import expandIcon from "../../assets/icons/expand.svg";
import "./Drafts.scss";
const { Option } = Select;

class Drafts extends Component {
  constructor(props) {
    super(props);
    this.state = {
      draft: [],
      expand: [],
      sortBy: "newest",
      XSsorter: false,
      searchValue: "",
      draftSearched: []
    };
    this.imageUploader = React.createRef();
  }

  handleToggleDetails = (id, toggle) => {
    let expand = this.state.expand;

    if (toggle) {
      expand.push(id);
    } else {
      const index = expand.indexOf(id);
      expand.splice(index, 1);
    }

    this.setState({ expand: expand });
  };

  handleSortBy = sortBy => {
    this.setState({
      sortBy,
      XSsorter: true
    });
  };

  handleXSSortBy = sortBy => {
    if (sortBy == "newest") {
      this.setState({
        sortBy,
        XSsorter: false
      });
    } else {
      this.setState({
        sortBy,
        XSsorter: true
      });
    }
  };

  handleSearch = e => {
    const result = Object.values(this.props.draftData.data).filter(row => {
      const search = arg => {
        if (arg) {
          return arg
            .toString()
            .toLowerCase()
            .includes(this.state.searchValue.toString().toLowerCase());
        }
      };
      return [row.product].some(
        row =>
          row
            .map(row => row)
            .map(row => row.product)
            .some(
              row =>
                search(row.name) ||
                search(row.description) ||
                search(row.category) ||
                search(row.country_made) ||
                search(row.brand.name)
            ) ||
          row
            .map(row => row)
            .map(row => row.variant)
            .some(
              row =>
                search(row.name) ||
                search(row.material_code) ||
                // search(row.variants.pricelist_per_distributor[0].special_code) ||
                search(row.packing_scheme) ||
                search(row.variants.size) ||
                search(row.variants.flavor) ||
                search(row.gross_weight) ||
                search(row.net_weight) ||
                search(row.description)
            )
      );
    });

    this.setState({
      searchValue: e.target.value.substr(0, 20),
      draftSearched: result
    });
  };

  searchResultIndicator = () => {
    const { searchValue, draftSearched } = this.state;
    if (searchValue) {
      if (draftSearched.length == 1) {
        return (
          <div className="search-result-indicator">{`${draftSearched.length}  Product Found`}</div>
        );
      } else if (draftSearched.length >= 1) {
        return (
          <div className="search-result-indicator">{`${draftSearched.length}  Products Found`}</div>
        );
      } else {
        return (
          <div className="search-result-indicator">{`${draftSearched.length}  Product Found`}</div>
        );
      }
    }
  };

  componentDidMount() {
    this.props.fetchPermissions();
    this.props.fetchDrafts();
  }

  handleCancelDraft(id) {
    this.props.cancelDraft(id);
  }

  componentDidUpdate(prevProps, prevState) {
    const { draftData } = this.props;
    const { searchValue, draftSearched } = this.state;

    if (this.state.draft !== draftData.data) {
      const expand =
        draftData.data && draftData.data.length > 0
          ? [draftData.data[0].id]
          : [];

      this.setState({
        draft: draftData.data,
        expand: expand
      });
    }

    if (prevState.searchValue !== this.state.searchValue) {
      if (this.state.searchValue.length >= 0) {
        this.setState({
          searchValue,
          draftSearched
        });
      }
    }
  }

  render() {
    const {
      myPermissions, myPermissionsIsFetching,
      fetching
    } = this.props;
    let { draft, expand, sortBy, searchValue, draftSearched } = this.state;
    draft = draft ? draft : [];

    if (sortBy === "newest") {
      draft.sort((a, b) => moment(b.created_at) - moment(a.created_at));
    } else if (sortBy !== "newest") {
      draft.sort((a, b) => moment(a.created_at) - moment(b.created_at));
    }

    const columns = [
      {
        title: "PRODUCTS",
        dataIndex: "variant.image",
        key: "variant.image",
        render: (image, row) => {
          // if (!image) {
          //   return "";
          // }
          return (
            <div className="product-information">
              <span
                className="product-image"
                style={{
                  backgroundImage: `url(${
                    image
                      ? `${config.REACT_APP_FILES_URL}${image}`
                      : "https://via.placeholder.com/100x100?text=No+Image"
                    })`
                }}
              />
              <span className="product-id">
                <h5>{row.product.brand.name}</h5>
                <h3>
                  {`${row.product.name} `}
                  {/* {`${row.product.name} 
                ${row.variant && row.variant.variants && row.variant.variants.flavor ? row.variant.variants.flavor.toLowerCase() : null} `} */}
                </h3>
              </span>
            </div>
          );
        }
      },
      {
        title: "VARIANTS",
        dataIndex: "variant",
        key: "variant",
        render: variant => variant.name
      },
      {
        title: "COUNTRY",
        dataIndex: "variant.country",
        key: "variant.country",
        align: "center"
      },
      {
        title: "TOTAL QTY.",
        dataIndex: "quantity",
        key: "quantity",
        align: "center",
        width: 260,
        render: quantity => quantity && quantity.toLocaleString()
      },
      {
        title: "TOTAL CBM",
        dataIndex: "variant.cbm",
        key: "variant.cbm",
        align: "center",
        width: 260,
        render: (cbm, row) => {
          return numberFormat(cbm * row.quantity);
        }
      },
      {
        title: "TOTAL AMOUNT",
        dataIndex: "selling_price",
        key: "selling_price",
        align: "center",
        width: 260,
        render: (selling_price, row) => {
          return `$ ${numberFormat(selling_price)}`;
        }
      }
    ];

    const meta = {
      title: "Drafts - URC Global Exports",
      description:
        "URC Global Exports seeks global awareness for its brands, enter new territories and explore untapped business opportunities. Learn more about us today!",
      canonical: window.location.href,
      meta: {
        charset: "utf-8",
        name: {
          keywords: "Drafts"
        }
      }
    };

    if (myPermissionsIsFetching) {
      return (
        <DocumentMeta {...meta}>
          <Layout>
            <Spin spinning={myPermissionsIsFetching}>
              <Skeleton active />
            </Spin>
          </Layout>
        </DocumentMeta>
      )
    }

    return (
      <DocumentMeta {...meta}>
        <Layout>
          {myPermissions.some(r => r.name === 'distributor.orders.view') ? <Layout.Content className="product-order-content">


            <Row gutter={48}>
              <Col className="product-order-form" span={24}>
                {/* HEADER */}
                <MediaQuery minWidth={1224}>
                  <div className="product-order-form-header">
                    <h2>Saved Drafts</h2>
                    <span>SORT BY</span>
                    <Select
                      style={{ width: 150 }}
                      placeholder="Date"
                      defaultValue={[sortBy]}
                      onChange={value => this.handleSortBy(value)}
                    >
                      <Option value="newest">Newest</Option>
                      <Option value="oldest">Oldest</Option>
                    </Select>
                  </div>
                </MediaQuery>
                <MediaQuery maxWidth={1224}>
                  <Row
                    type="flex"
                    justify="space-between"
                    align="middle"
                    className="sub-header"
                  >
                    <Col>
                      <h2>Saved Drafts</h2>
                    </Col>
                    <Col>
                      <a
                        onClick={() =>
                          this.handleXSSortBy(
                            this.state.XSsorter ? "newest" : "oldest"
                          )
                        }
                      >
                        <img src={swap} alt="" />
                      </a>
                    </Col>
                  </Row>
                </MediaQuery>
                <div className="draft-search-holder search-container">
                  <Input.Search
                    placeholder="Search"
                    prefix={<Icon type="search" />}
                    value={this.state.searchValue}
                    onChange={this.handleSearch}
                    size="large"
                  />
                </div>
                {this.searchResultIndicator()}
                <div className="product-order-result">
                  {draft && draft.length > 0 ? (
                    (searchValue.length >= 1 ? draftSearched : draft).map(
                      (order, index) => {
                        let product = order.product || [];
                        let cbm, price, quantity;
                        if (product.length > 0) {
                          cbm = _.chain(product)
                            .map(
                              product =>
                                (product.variant.cbm || 0) *
                                parseInt(product.quantity)
                            )
                            .sum()
                            .value();
                          price = _.chain(product)
                            .map(
                              product =>
                                (product.selling_price || 0) *
                                parseInt(product.quantity)
                            )
                            .sum()
                            .value();
                          quantity = _.chain(product)
                            .map(product => parseInt(product.quantity))
                            .sum()
                            .value();
                        }
                        return (
                          <Row type="flex" key={index} className="wrapper">
                            <Col
                              span={24}
                              className={
                                expand.indexOf(order.id) > -1
                                  ? ""
                                  : "wrapper-child-conditional"
                              }
                            >
                              <Row
                                type="flex"
                                justify="space-between"
                                align="middle"
                              >
                                <Col span={14}>
                                  <Row type="flex" align="middle">
                                    <Col>
                                      <span className="order-date">
                                        {moment(order.created_at).format(
                                          "MMMM DD, YYYY"
                                        )}
                                      </span>
                                    </Col>
                                    <span className="separator">&#9679;</span>
                                    {/* <Col>
                                      <span className="order-number">
                                        {order ? order.transaction_number : ""}
                                      </span>
                                    </Col>
                                    <span className="separator">&#9679;</span> */}
                                    <Col>
                                      <span className="product-order-length">
                                        {order.product.length} Product/s on
                                        Draft
                                      </span>
                                    </Col>
                                  </Row>
                                </Col>
                                <Col span={10} align="right">
                                  <Button
                                    disabled={!myPermissions.some(r => r.name === 'distributor.orders.edit')}
                                    type="link"
                                    onClick={() =>
                                      this.props.history.push(
                                        `order?draftId=${order.product[0].distributor_draft_id}`
                                      )
                                    }
                                  >
                                    <b>
                                      <Icon type="edit" />
                                      &nbsp; EDIT DRAFT
                                    </b>
                                  </Button>
                                </Col>
                              </Row>
                            </Col>

                            <Col span={24} style={{ overflowX: "auto" }}>
                              <List
                                bordered
                                itemLayout="horizontal"
                                dataSource={product}
                                renderItem={(row, index) => {
                                  return (
                                    <List.Item
                                      className="product"
                                      style={{
                                        display:
                                          expand.indexOf(order.id) > -1
                                            ? "block"
                                            : "none"
                                      }}
                                    >
                                      <MediaQuery minWidth={1224}>
                                        <Row
                                          gutter={24}
                                          type="flex"
                                          align="middle"
                                        >
                                          <Col span={3}>
                                            <span>{index + 1}</span>
                                          </Col>
                                          <Col span={3}>
                                            <span>{`${row.variant.pricelist_per_distributor[0].special_code !== null ? row.variant.pricelist_per_distributor[0].special_code : row.variant.material_code}`}</span>
                                          </Col>
                                          <Col span={4}>
                                            <div className="product-information">
                                              <span className="product-id">
                                                <h5>
                                                  {row.product.brand.name}
                                                </h5>
                                                <h3>{`${row.product.name} `}</h3>
                                              </span>
                                            </div>
                                          </Col>
                                          <Col span={3}>
                                            <span>
                                              {row.variant.packing_scheme}
                                            </span>
                                          </Col>
                                          <Col span={4} align="right">
                                            {row.quantity.toLocaleString()}
                                          </Col>
                                          <Col span={2} align="right">
                                            {numberFormat(
                                              row.variant.cbm * row.quantity
                                            )}
                                          </Col>
                                          <Col span={3} align="right">
                                            ${" "}
                                            {numberFormat(
                                              row.selling_price * row.quantity
                                            )}
                                          </Col>
                                        </Row>
                                      </MediaQuery>
                                      <MediaQuery maxWidth={1224}>
                                        <Card className="card-info">
                                          <Row
                                            type="flex"
                                            justify="start"
                                            align="middle"
                                          >
                                            <Col span={12}>
                                              <small>Line #</small>
                                              <br />
                                              <span>{index + 1}</span>
                                            </Col>
                                            <Col span={11} offset={1}>
                                              <small>SKU Code</small> <br />
                                              <span>{`${row.variant.pricelist_per_distributor[0].special_code !== null ? row.variant.pricelist_per_distributor[0].special_code : row.variant.material_code}`}</span>
                                            </Col>
                                            <Col span={24}>
                                              <small>SKU DESCRIPTION</small>
                                              <br />
                                              <span>
                                                {`${row.product.brand.name} ${row.variant.name}`}
                                              </span>
                                            </Col>
                                            <Col span={12}>
                                              <small>Packing Scheme</small>
                                              <br />
                                              <span>
                                                {row.variant.packing_scheme}
                                              </span>
                                            </Col>
                                            <Col span={11} offset={1}>
                                              <small>AMOUNT (IN USD)</small>
                                              <br />
                                              $&nbsp;
                                              <span>
                                                {numberFormat(
                                                  row.selling_price *
                                                  row.quantity
                                                )}
                                              </span>
                                            </Col>
                                            <Col span={12}>
                                              <small>
                                                ORDERED QTY. (IN CS)
                                              </small>
                                              <br />
                                              <span>
                                                {row.quantity.toLocaleString()}
                                              </span>
                                            </Col>
                                            <Col span={11} offset={1}>
                                              <small>CBM</small> <br />
                                              <span>
                                                {numberFormat(
                                                  row.variant.cbm * row.quantity
                                                )}
                                              </span>
                                            </Col>
                                          </Row>
                                        </Card>
                                      </MediaQuery>
                                    </List.Item>
                                  );
                                }}
                                header={
                                  <Row gutter={24}>
                                    <Col span={3}>
                                      <h3>LINE #</h3>
                                    </Col>
                                    <Col span={3}>
                                      <h3>SKU Code</h3>
                                    </Col>
                                    <Col span={4}>
                                      <h3>SKU Description</h3>
                                    </Col>
                                    <Col span={3}>
                                      <h3>Packing Scheme</h3>
                                    </Col>
                                    <Col span={4} align="right">
                                      <h3>Ordered QTY. (IN CS)</h3>
                                    </Col>
                                    <Col span={2} align="right">
                                      <h3>CBM</h3>
                                    </Col>
                                    <Col span={3} align="right">
                                      <h3>AMOUNT (IN USD)</h3>
                                    </Col>
                                    <Col
                                      span={2}
                                      style={{ textAlign: "right" }}
                                    >
                                      {myPermissions.some(r => r.name === 'distributor.orders.cancel')?(
                                        <Icon
                                        type="close"
                                        onClick={() =>
                                          this.handleCancelDraft(
                                            order.product[0]
                                              .distributor_draft_id
                                          )
                                        }
                                      />
                                      ):''}
                                      
                                    </Col>
                                  </Row>
                                }
                                footer={
                                  <>
                                    <MediaQuery minWidth={1224}>
                                      <Card
                                        style={{
                                          padding: "30px 20px",
                                          borderTop: "none",
                                          borderRight: "none",
                                          borderLeft: "none"
                                        }}
                                      >
                                        <Row
                                          type="flex"
                                          justify="space-between"
                                          align="middle"
                                          className="order-draft-footer"
                                        >
                                          <Col xs={24} md={12}>
                                            {expand.indexOf(order.id) > -1 ? (
                                              <span
                                                className="toggle-button"
                                                onClick={() =>
                                                  this.handleToggleDetails(
                                                    order.id,
                                                    false
                                                  )
                                                }
                                              >
                                                Shorten Order Details ^
                                              </span>
                                            ) : (
                                                <span
                                                  className="toggle-button"
                                                  onClick={() =>
                                                    this.handleToggleDetails(
                                                      order.id,
                                                      true
                                                    )
                                                  }
                                                >
                                                  Expand Order Details
                                                </span>
                                              )}
                                          </Col>
                                          <Col xs={24} md={12}>
                                            <Row
                                              type="flex"
                                              justify="space-between"
                                              align="middle"
                                              className="draft-footer"
                                              gutter={16}
                                            >
                                              <Col md={8} lg={8} align="center">
                                                <label>TOTAL QUANTITY:</label>
                                                &nbsp;
                                                <span>
                                                  {quantity &&
                                                    quantity.toLocaleString()}
                                                </span>
                                              </Col>
                                              <Col md={7} lg={7} align="center">
                                                <label>TOTAL CBM:</label>
                                                &nbsp;
                                                <span>{numberFormat(cbm)}</span>
                                              </Col>
                                              <Col md={9} lg={9} align="center">
                                                <label>TOTAL AMOUNT: </label>
                                                <span>
                                                  $ {numberFormat(price)}
                                                </span>
                                              </Col>
                                            </Row>
                                          </Col>
                                        </Row>
                                      </Card>
                                    </MediaQuery>
                                    <MediaQuery maxWidth={1224}>
                                      <Row
                                        type="flex"
                                        justify="space-between"
                                        align="middle"
                                        className={
                                          expand.indexOf(order.id) > -1
                                            ? "row-expand expand-border-top"
                                            : "row-expand "
                                        }
                                      >
                                        <Col span={2}>
                                          {expand.indexOf(order.id) > -1 ? (
                                            <span
                                              className="toggle-button"
                                              onClick={() =>
                                                this.handleToggleDetails(
                                                  order.id,
                                                  false
                                                )
                                              }
                                            >
                                              <img src={expandIcon} alt="" />
                                            </span>
                                          ) : (
                                              <span
                                                className="toggle-button"
                                                onClick={() =>
                                                  this.handleToggleDetails(
                                                    order.id,
                                                    true
                                                  )
                                                }
                                              >
                                                <img src={expandIcon} alt="" />
                                              </span>
                                            )}
                                        </Col>
                                        <Col span={22}>
                                          <Row
                                            type="flex"
                                            justify="space-between"
                                            align="middle"
                                          >
                                            <Col span={10}>
                                              <label>TOTAL AMOUNT:</label>
                                              <br />
                                              <span>
                                                $&nbsp;{numberFormat(price)}
                                              </span>
                                            </Col>
                                            <Col span={7}>
                                              <label>TOTAL QTY:</label>
                                              <br />
                                              <span>
                                                {quantity &&
                                                  quantity.toLocaleString()}
                                              </span>
                                            </Col>
                                            <Col span={7}>
                                              <label>TOTAL CBM:</label>
                                              <br />
                                              <span>{numberFormat(cbm)}</span>
                                            </Col>
                                          </Row>
                                        </Col>
                                      </Row>
                                    </MediaQuery>
                                  </>
                                }
                              />
                            </Col>
                          </Row>
                        );
                      }
                    )
                  ) : (
                      <Row
                        type="flex"
                        align="middle"
                        justify="center"
                        style={{ marginTop: "50px" }}
                      >
                        <Col>
                          {fetching ? <Spin /> : <h1>No Saved Drafts</h1>}
                        </Col>
                      </Row>
                    )}
                </div>
              </Col>
            </Row>
          </Layout.Content>
            : <Result
              status="warning"
              title="You have no permission to view this page."
            />
          }
        </Layout>
      </DocumentMeta>
    );
  }
}

const mapStateToProps = state => {
  const {
    permissions,
    drafts
  } = state;

  return {
    myPermissions: permissions.data,
    myPermissionsIsFetching: permissions.fetching,
    draftData: drafts,
    fetching: drafts.fetching
  };
};

export default connect(mapStateToProps, {
  fetchPermissions,
  fetchDrafts,
  cancelDraft
})(reduxForm({ form: "draftForm", enableReinitialize: true })(Drafts));
